import { createSelector } from 'reselect';
import { RouteParams } from './customer.selectors';
import { isNil, propOr } from 'ramda';
import { generateTitle, getCreationDate } from '../../components/giftCard/gift.card.helper';
export var GiftCardResultStoreSelector = function GiftCardResultStoreSelector(state) {
  return state.customercare.giftCardResult;
};
export var CurrentGiftCardIdSelector = createSelector([RouteParams], function (routeParams) {
  return parseInt(routeParams.giftCardId, 10);
});
export var IsLoadingDataSelector = createSelector([GiftCardResultStoreSelector], function (giftCard) {
  return giftCard.isFetchingGiftCard;
});
export var CurrentGiftCardSelector = createSelector([GiftCardResultStoreSelector], function (giftCard) {
  if (!isNil(giftCard.data)) {
    var gc = Object.assign({}, giftCard.data);
    gc.creationDate = getCreationDate(giftCard.data);
    gc.title = generateTitle(giftCard.data);
    return gc;
  }
  return null;
});
export var GiftCardNotificationErrorSelector = createSelector([GiftCardResultStoreSelector], function (giftCard) {
  return propOr(null, 'giftCardNotificationError', giftCard);
});
export var IsResendingGiftCardNotificationSelector = createSelector([GiftCardResultStoreSelector], function (giftCard) {
  return propOr(false, 'isResendingGiftCardNotification', giftCard);
});